import React, { useState } from 'react'
import ThemedPressable from 'components/atoms/ThemedPressable'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { styles } from 'scenes/home/coworker/filter/_styles'
import { colorList } from 'utils/colors'
import ListItem from 'components/atoms/ListItem'
import _ from 'lodash'
import FetchManagementTeam from 'utils/fetch/management/FetchManagementTeam'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import i18n from 'utils/i18n'
import Spinner from "theme/Spinner";
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form from 'components/molecules/Form'
import HelperString from 'utils/helper-string'
import ThemedList from 'components/atoms/ThemedList'

const SearchSelectTeamComponent = ({ selectedTeams = [], subtitle = true, readonly = false, onSubmit }) => {
	
	const [ results, setResults ] = useState( [] )
	const [ searching, setSearching ] = useState( false )
	const [ availableFor, setAvailableFor ] = useState( selectedTeams )
	
	const renderTeamListItem = ( { item } ) => {
		let title = item?.name;
		
		let accessoryRight = null;
		if( !readonly ) {
			accessoryRight = (
				<ThemedPressable onPress={ onTeamRemove.bind( this, item.guid ) }>
					<Icon
						icon={ IconSystemConstants.TRASH }
						style={ styles.icon }
						color={ colorList.RED.primary }
					/>
				</ThemedPressable>
			)
		}
		
		return (
			<ListItem
				title={ title }
				accessoryRight={ accessoryRight }
			/>
		)
	}
	
	const onTeamSelect = ( index ) => {
		// check if it's already added
		let added = false;
		
		availableFor.forEach( o => {
			if( o.guid === results[ index ]?.guid ) {
				added = true;
			}
		});
		
		const newAvailableFor = added ? availableFor : [ ...availableFor, results[ index ] ];
		
		setAvailableFor( newAvailableFor );
	}
	
	const onTeamRemove = ( guid ) => {
		setAvailableFor( availableFor.filter( item => {
			return item.guid !== guid;
		} ) )
	}
	
	const searchTeamChanged = ( value ) => {
		// Always lowercase
		value = value?.toLowerCase() ?? '';
		
		// Only when there is a value do a fetch :)
		if( !_.isEmpty( value ) ) {
			FetchManagementTeam.fetchAll({
				employeeCount: false,
				dispatchDataToStore: false,
				variables: {
					search: value
				},
				callbackStart: () => {
					setSearching( true )
					setResults( [] )
				},
				callbackSuccess: ( { teams } ) => {
					setSearching( false )
					setResults( teams )
				},
				callbackError: ( result ) => {
					setSearching( false )
					setResults( [] )
				}
			})
		}
	}
	
	const saveAvailableForTeamsForm = ( values, { callback } = {} ) => {
		const teams = [];
		availableFor.forEach( ( team ) => {
			teams.push( team.guid );
		})
		
		onSubmit( teams, { callback })
	}
	
	const teamOptions = _.map( results, team => {
		return {
			title: team.name
		};
	});
	
	// Create the available for fields
	const formFieldsAvailableFor = [
		{
			name: 'teams',
			required: true,
			label: i18n.t('management:form.teams.title'),
			type: FormFieldsConstants.AUTOCOMPLETE,
			onSelect: onTeamSelect,
			onChangeText: _.debounce( searchTeamChanged.bind( this ), 400 ),
			options: teamOptions,
			accessoryRight: searching ? () => {
				return <Spinner size='small' color={colorList.PRIMARY.primary} />;
			} : null
		},
	];
	
	return (
		<ThemedBlock
			header={[
				i18n.t('management:form.available_for.title'),
				subtitle === true ? i18n.t('management:form.available_for.description') : null
			]}
			shadow
			mediumPadding>
			
			{ !readonly && (
				<Form
					key={ HelperString.hash( 'form-available-for-teams' ) }
					fields={ formFieldsAvailableFor }
					onSubmit={ saveAvailableForTeamsForm }
					forceSaveButton={ true }
				/>
			)}
			
			<ThemedList
				data={ _.filter( availableFor ) }
				renderItem={ renderTeamListItem.bind( this ) }
			/>
		</ThemedBlock>
	);
}

export default SearchSelectTeamComponent
